import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostFotoKategorieCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostFotoKategorieCommandService],
  exports: []
})
export class PostFotoKategorieCommandServiceModule { }
